import React from 'react'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList, Tooltip, CartesianGrid } from 'recharts'
import styles from "../charts.module.css"
import { formatValueWithUnit } from '../chartUtils'

const ChartBar = ({ data, color = "var(--brand-primary)", unit = "" }) => {
    const allDataZero = data.every(item => item.value === 0)

    const CustomLabel = (props) => {
        const { x, y, width, height, value } = props
        if (!value) return null

        if (width < 34) return null

        return (
            <text
                x={x + width - 10}
                y={y + height / 2}
                className={styles.barValueLabel}
                textAnchor="end"
                dominantBaseline="middle"
                fontSize={12}
                fontWeight={800}
            >
                {value}
            </text>
        )
    }

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const item = payload[0].payload

            return (
                <div className={styles.tooltip}>
                    <p>
                        <span className={styles.tooltipLabel}>{item.name}</span>
                        <span className={styles.tooltipValue}>{item.formattedValue || formatValueWithUnit(item.value, unit)}</span>
                        {item.quantity !== undefined && (
                            <span style={{ fontWeight: "bold" }}> ({item.quantity} {item.quantity === 1 ? "item" : "itens"})</span>
                        )}
                    </p>
                </div>
            )
        }

        return null
    }

    const formatText = (text) => {
        const words = text.split(" ")

        const abbreviatedWords = words.map((word, index) => {
            if (index !== words.length - 1 && word.length > 3) {
                return word.substring(0, 3) + '.'
            }
            return word
        })

        return abbreviatedWords.join(" ")
    }

    return (
        allDataZero ? (
            <div className={styles.emptyChartMessage}>
                <p>Nenhum dado para exibir</p>
            </div>
        ) : (
            <ResponsiveContainer width="100%" height="100%">
                <BarChart layout="vertical" data={data} margin={{ top: 8, right: 18, left: 0, bottom: 8 }} barCategoryGap={12}>
                    <CartesianGrid stroke="var(--border-subtle-color)" strokeDasharray="4 8" horizontal={false} />
                    <XAxis type="number" dataKey="value" hide={true} />
                    <YAxis
                        type="category"
                        dataKey="name"
                        width={180}
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(value) => formatText(value)}
                    />
                    <Tooltip content={<CustomTooltip />} offset={12} wrapperStyle={{ outline: "none" }} />
                    <Bar
                        dataKey="value"
                        fill={color}
                        radius={[0, 8, 8, 0]}
                        maxBarSize={26}
                        background={{ fill: "var(--surface-hover)", radius: 8 }}
                    >
                        <LabelList dataKey="formattedValue" content={<CustomLabel />} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        )
    )
}

export default ChartBar
